import { render, staticRenderFns } from "./AdminAusstattungen.vue?vue&type=template&id=82a20b14&scoped=true&"
import script from "./AdminAusstattungen.vue?vue&type=script&lang=js&"
export * from "./AdminAusstattungen.vue?vue&type=script&lang=js&"
import style0 from "./AdminAusstattungen.vue?vue&type=style&index=0&id=82a20b14&prod&lang=css&"
import style1 from "./AdminAusstattungen.vue?vue&type=style&index=1&id=82a20b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a20b14",
  null
  
)

export default component.exports